import API from '../../../services/API';
import { setError, startSpinner, stopSpinner } from '../../common/actionCreators';
import { configs } from '../../../constants/configs/configs';

import {
    COMMUNICATION_PREFERENCES_ACTION_TYPES,
    communicationPreferencesSagaActionTypes
} from '../../../constants/actionTypes/dashboardActionTypes';

// Types

import { CommunicationPreferences, ReduxAction } from '../../../components/ssap/SsapTypes';

interface CommunicationPreferencesResponse {
    message: null | string,
    payload: CommunicationPreferences,
    success: boolean
}


const actions: { [ key: string ]: Function } = { setError, startSpinner, stopSpinner };
const URL = configs.endpoints.COMMUNICATION_PREFERENCES;
const URL_TELEX_ENV = configs.endpoints.TELEX_ENVIRONMENT;
const URL_PARTIAL_UPDATE = configs.endpoints.PARTIAL_UPDATE;
const URL_OTP_VERIFY = configs.endpoints.OTP_VERIFY;
const URL_OTP_SEND = configs.endpoints.OTP_SEND;

// Async ActionCreators

export const fetchExchangeDetails = () => async (dispatch, getState): Promise<any> => {

    const response: CommunicationPreferencesResponse = await API.getData(URL_TELEX_ENV, dispatch, actions, true, getState());

    if (response) {
        return response;
    }
};

export const fetchPreferences = () => async (dispatch, getState): Promise<any> => {

    const response: CommunicationPreferencesResponse = await API.getData(URL, dispatch, actions, true, getState());

    if (response) {
        return response;
    }
};

export const savePreferences = (...args) => async (dispatch, getState): Promise<any> => {

    const [ body ] = args;
    let response: CommunicationPreferencesResponse;

    if (configs.ENV.DEVELOPMENT) {
        response = await API.getData(URL, dispatch, actions, true, getState());
    } else {
        response = await API.postData([URL, body], dispatch, actions);
    }

    if(response) {
        return response;
    }
};

export const partialUpdatePreferences = (...args) => async (dispatch, getState): Promise<any> => {
    const [body] = args;

    let response: CommunicationPreferencesResponse;

    if (configs.ENV.DEVELOPMENT) {
        response = await API.getData(URL_PARTIAL_UPDATE, dispatch, actions, true, getState());
    } else {
        response = await API.postData([URL_PARTIAL_UPDATE, body], dispatch, actions);
    }

    if (response) {
        return response;
    }
}

export const otpVerify = (...args) => async (dispatch, getState): Promise<any> => {
    const [body] = args;

    let response: CommunicationPreferencesResponse;

    if (configs.ENV.DEVELOPMENT) {
        response = await API.getData(URL_OTP_VERIFY, dispatch, actions, true, getState());
    } else {
        response = await API.postData([URL_OTP_VERIFY, body], dispatch, actions);
    }

    if (response) {
        return response;
    }
}

export const otpSend = (...args) => async (dispatch, getState): Promise<any> => {
    const [body] = args;
    let response: CommunicationPreferencesResponse;

    if (configs.ENV.DEVELOPMENT) {
        response = await API.getData(URL_OTP_SEND, dispatch, actions, true, getState());
    } else {
        response = await API.postData([URL_OTP_SEND, body], dispatch, actions);
    }

    if (response) {
        return response;
    }
}

// Sync action creators

export const setCommunicationPreferences = (preferences: CommunicationPreferences): ReduxAction => ({
    type: COMMUNICATION_PREFERENCES_ACTION_TYPES.SET_COMMUNICATION_PREFERENCES,
    preferences
});


// communicationPreferencesSagaActions

export const fetchCommunicationPreferences = (): ReduxAction => ({
    type: communicationPreferencesSagaActionTypes.FETCH_COMMUNICATION_PREFERENCES
});

export const fetchCommunicationPreferencesFailure = (): ReduxAction => ({
    type: communicationPreferencesSagaActionTypes.FETCH_COMMUNICATION_PREFERENCES_FAILURE
});

export const fetchCommunicationPreferencesSuccess = (): ReduxAction => ({
    type: communicationPreferencesSagaActionTypes.FETCH_COMMUNICATION_PREFERENCES_SUCCESS
});